module.exports = __webpack_public_path__ + "img/2.7c71d90a.png";